import React from "react";

/** Minimal Swiss-styled modal without shadcn Dialog to keep sharp edges. */
export default function Modal({ open, onClose, title, children, testId, maxWidth = "max-w-lg" }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center p-4 overflow-y-auto"
      onClick={onClose}
      data-testid={testId || "modal"}
    >
      <div
        className={`bg-white border border-stone-950 w-full ${maxWidth} mt-10 md:mt-20 shadow-xl`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-stone-200 p-5">
          <div>
            <div className="overline text-brand-600">Form</div>
            <h3 className="font-display text-xl font-bold text-stone-950 mt-0.5">{title}</h3>
          </div>
          <button
            onClick={onClose}
            data-testid="modal-close"
            className="text-stone-500 hover:text-stone-950 text-xl leading-none font-bold"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children, testId }) {
  return (
    <label className="block mb-4" data-testid={testId}>
      <div className="overline text-stone-500 mb-2">{label}</div>
      {children}
    </label>
  );
}

export function TextInput({ testId, ...props }) {
  return (
    <input
      data-testid={testId}
      {...props}
      className={`w-full border border-stone-300 bg-white px-3 py-2 text-base focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 focus:outline-none ${
        props.className || ""
      }`}
    />
  );
}

export function TextArea({ testId, ...props }) {
  return (
    <textarea
      data-testid={testId}
      {...props}
      className={`w-full border border-stone-300 bg-white px-3 py-2 text-base focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 focus:outline-none ${
        props.className || ""
      }`}
    />
  );
}

export function Select({ testId, children, ...props }) {
  return (
    <select
      data-testid={testId}
      {...props}
      className={`w-full border border-stone-300 bg-white px-3 py-2 text-base focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 focus:outline-none ${
        props.className || ""
      }`}
    >
      {children}
    </select>
  );
}

export function PrimaryButton({ testId, children, ...props }) {
  return (
    <button
      data-testid={testId}
      {...props}
      className={`bg-brand-500 hover:bg-brand-600 disabled:bg-stone-300 text-white font-bold uppercase tracking-wider text-sm py-2.5 px-4 transition-colors ${
        props.className || ""
      }`}
    >
      {children}
    </button>
  );
}

export function SecondaryButton({ testId, children, ...props }) {
  return (
    <button
      data-testid={testId}
      {...props}
      className={`border border-stone-950 text-stone-950 bg-transparent hover:bg-stone-950 hover:text-white font-bold uppercase tracking-wider text-sm py-2.5 px-4 transition-colors ${
        props.className || ""
      }`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ testId, children, ...props }) {
  return (
    <button
      data-testid={testId}
      {...props}
      className={`text-stone-700 hover:text-stone-950 hover:bg-stone-100 font-medium text-sm py-1.5 px-3 transition-colors ${
        props.className || ""
      }`}
    >
      {children}
    </button>
  );
}
